import React, { useEffect, useState } from "react";
import Axios from "../../utils/Axios";
import toast from "react-hot-toast";

const FriendRequests = () => {
  const [requests, setRequests] = useState([]);

  const fetchRequests = async () => {
    try {
      const res = await Axios.get("/api/user/friend-requests");
      setRequests(res.data.friendRequests);
    } catch (err) {
      toast.error("Failed to load friend requests.");
    }
  };

  useEffect(() => {
    fetchRequests();
  }, []);

  const respondRequest = async (senderId, action) => {
    try {
      const res = await Axios.post("/api/user/respond-follow-request", {
        senderId,
        action,
      });
      toast.success(res.data.message);
      setRequests((prev) => prev.filter((r) => r._id !== senderId));
    } catch (err) {
      toast.error("Failed to respond to request.");
    }
  };

  return (
    <div>
  <h2>Friend Requests</h2>
  {requests.length === 0 && <p>No pending friend requests.</p>}
  {requests.map((req) => (
    <div
      key={req._id}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "12px", // spacing between name and buttons
        marginBottom: "1rem", // spacing between each request block
      }}
    >
      <span>{req.name}</span>
      <button onClick={() => respondRequest(req._id, "accept")}>Accept</button>
      <button onClick={() => respondRequest(req._id, "decline")}>Decline</button>
    </div>
  ))}
</div>
  )}

export default FriendRequests;
